import { useNavigate } from "react-router-dom";
import { Wallet, Calendar } from "lucide-react";

/* ===========================
   CONFIGURACIÓN WHATSAPP
=========================== */
const WHATSAPP_LINK =
  "https://wa.me/51985138443?text=Hola,%20represento%20a%20una%20empresa%20y%20quiero%20evaluar%20mi%20factura%20eléctrica%20con%20SERGEN";

const HeroLanding = () => {
  const navigate = useNavigate();

  /* ===========================
     EVENTO WHATSAPP (GTM)
  =========================== */
  const handleWhatsAppClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    // Emitimos evento personalizado para GTM
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "whatsapp_click",
      source: "hero_landing",
    });

    // Abrimos WhatsApp
    window.open(WHATSAPP_LINK, "_blank");
  };

  return (
    <section className="relative w-full bg-white overflow-hidden">
      {/* ===== BOLAS DECORATIVAS ===== */}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute top-20 left-12 w-20 h-20 rounded-full" style={{ backgroundColor: "rgba(245,165,36,0.10)" }} />
        <div className="absolute top-44 left-36 w-14 h-14 rounded-full" style={{ backgroundColor: "rgba(242,140,0,0.08)" }} />
        <div className="absolute top-1/2 left-6 w-28 h-28 rounded-full" style={{ backgroundColor: "rgba(245,165,36,0.08)" }} />
        <div className="absolute top-16 left-1/2 w-16 h-16 rounded-full" style={{ backgroundColor: "rgba(242,140,0,0.08)" }} />
        <div className="absolute top-28 right-24 w-24 h-24 rounded-full" style={{ backgroundColor: "rgba(245,165,36,0.10)" }} />
        <div className="absolute top-1/2 right-14 w-20 h-20 rounded-full" style={{ backgroundColor: "rgba(242,140,0,0.08)" }} />
        <div className="absolute bottom-24 right-32 w-32 h-32 rounded-full" style={{ backgroundColor: "rgba(245,165,36,0.08)" }} />
      </div>

      {/* ===== CONTENIDO ===== */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-28">
        <div className="grid grid-cols-1 md:grid-cols-[420px_1fr] gap-10 items-center">

          {/* LEFT – TEXTO */}
          <div className="font-sans max-w-[520px]">

            {/* BADGE SUPERIOR – FILTRO EMPRESAS */}
            <div className="inline-flex items-center mb-4">
              <span
                className="
                  px-4 py-1.5
                  rounded-full
                  text-sm font-medium
                  text-[#C86A00]
                  bg-[#F39200]/15
                  border border-[#F39200]/30
                "
              >
                Soluciones para industrias
              </span>
            </div>

            {/* TÍTULO */}
            <h1 className="text-5xl md:text-6xl font-medium text-black tracking-tight leading-tight mb-6">
              <span className="block whitespace-nowrap">
                Reducimos tu Factura
              </span>
              <span className="block whitespace-nowrap">
                Eléctrica{" "}
                <span className="font-bold text-[#F39200]">Hasta en 36%</span>
              </span>
            </h1>

            {/* SUBTEXTO */}
            <p className="text-lg md:text-xl text-slate-600 mb-10">
              Dirigido a compañías con facturación eléctrica mayor a S/20,000 mensuales.
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4">

              {/* CTA – WhatsApp (CONVERSIÓN PRINCIPAL) */}
              <button
                type="button"
                onClick={handleWhatsAppClick}
                className="
                  group
                  px-8 py-4 rounded-full
                  bg-white text-[#F28C00]
                  text-base font-medium
                  whitespace-nowrap
                  flex items-center justify-center gap-2
                  shadow-[0_6px_14px_rgba(242,140,0,0.18)]
                  transition-all duration-200
                  hover:bg-[#F28C00]
                  hover:text-white
                  hover:-translate-y-[1px]
                  hover:shadow-[0_10px_24px_rgba(242,140,0,0.28)]
                "
              >
                <Wallet
                  size={18}
                  className="
                    text-[#F28C00]
                    transition-colors duration-200
                    group-hover:text-white
                  "
                />
                Evaluar mi factura eléctrica
              </button>

              {/* CTA – Agendar diagnóstico (SECUNDARIO) */}
              <button
                type="button"
                onClick={() => navigate("/agenda")}
                className="
                  group
                  px-8 py-4 rounded-full
                  bg-white text-[#F28C00]
                  text-base font-medium
                  whitespace-nowrap
                  flex items-center justify-center gap-2
                  shadow-[0_6px_14px_rgba(242,140,0,0.18)]
                  transition-all duration-200
                  hover:bg-[#F28C00]
                  hover:text-white
                  hover:-translate-y-[1px]
                  hover:shadow-[0_10px_24px_rgba(242,140,0,0.28)]
                "
              >
                <Calendar
                  size={18}
                  className="
                    text-[#F28C00]
                    transition-colors duration-200
                    group-hover:text-white
                  "
                />
                Agendar un diagnóstico
              </button>

            </div>
          </div>

          {/* RIGHT – VIDEO */}
          <div className="relative ml-auto -mr-32 lg:-mr-48 w-full">
            <div className="w-full max-w-[980px] h-[420px] md:h-[480px] rounded-xl overflow-hidden shadow-xl">
              <video
                src="/VIDEO3-sergen.mp4"
                autoPlay
                muted
                loop
                playsInline
                className="w-full h-full object-cover"
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HeroLanding;
